"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.applyMapSearchToSearchQuery = exports.searchSetToUrlAsync = exports.getBuildingLinkFromSearchSet = exports.hfilterToSearchQuery = exports.sfilterToSearchQuery = exports.filterFollowPlaces = exports.filterSavedSeaches = exports.sfavSaveSearchSagas = void 0;
var effects_1 = require("redux-saga/effects");
var SfavAction_1 = require("@/pages/search/actions/sfilter/SfavAction");
var stateFilter_1 = require("@/pages/common/sagas/stateFilter");
var SaveSearchApiSaga_1 = require("@/pages/search/sagas/api/SaveSearchApiSaga");
var SaveSearchSet_1 = require("@/pages/common/states/SaveSearchSet");
var format_1 = require("@/utils/format");
var RootSaga_1 = require("@/pages/common/sagas/RootSaga");
var SfilterTypeGroup_1 = require("@/pages/common/states/sfilter/sections/SfilterTypeGroup");
var PlaceFollowedApiSaga_1 = require("@/pages/place/sagas/api/PlaceFollowedApiSaga");
var setOrderToSearchQuery_1 = require("@/transformers/setOrderToSearchQuery");
var searchQueryToUrl_1 = require("@/transformers/searchQueryToUrl");
var stateToSearchQuery_1 = require("@/transformers/stateToSearchQuery");
var SfavSaveSearchCallSaga_1 = require("@/pages/search/sagas/SfavSaveSearchCallSaga");
var GlobalCallSaga_1 = require("@/pages/common/sagas/GlobalCallSaga");
var UpdateSaveSearchCallSaga_1 = require("@/pages/savesearch/sagas/UpdateSaveSearchCallSaga");
var getCurrentHfilter = function (state) { return state.hfilter; };
// const getAllDistricts = (state: RootFilterState) => state.sfilter.district.options;
var getSearchIdHash = function (id) { return "searchid=" + id; };
var filterSavedSeaches = function (it) {
    return !it.searchSaveSetType || it.searchSaveSetType === SaveSearchSet_1.SearchSaveSetType.Search || it.searchSaveSetType === SaveSearchSet_1.SearchSaveSetType.Map;
};
exports.filterSavedSeaches = filterSavedSeaches;
var filterFollowPlaces = function (it) {
    return it.searchSaveSetType === SaveSearchSet_1.SearchSaveSetType.Building ||
        it.searchSaveSetType === SaveSearchSet_1.SearchSaveSetType.District;
};
exports.filterFollowPlaces = filterFollowPlaces;
/* Convert a search set object to district page url */
var getDistrictLinkFromSearchSet = function (searchSet) {
    var langs, lang, districtId;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects_1.select(RootSaga_1.getAvailableLanguages)];
            case 1:
                langs = _a.sent();
                lang = langs.filter(function (it) { return it.id === searchSet.languageId; })[0].code1;
                districtId = parseInt(searchSet.district.split(',')[0], 10);
                return [2 /*return*/, ''
                    // const districts: SfilterDistrictItem[] = yield select(getAllDistricts);
                    // const districtName = districts.find(it => it.id === districtId).name;
                    // const nameNormalized = format.normalize(districtName);
                    // return `/${lang}/district/${nameNormalized}/${districtId}`;
                ];
        }
    });
};
/* Convert a filter object to search query */
var sfilterToSearchQuery = function (sfilter, currencyId, langId, pageSize) {
    if (pageSize === void 0) { pageSize = 24; }
    return stateToSearchQuery_1.stateToSearchQuery({
        sfilter: sfilter,
        layout: {
            currencies: {
                currentCurrencyId: currencyId,
            },
            language: {
                current: langId,
            },
        },
    }, pageSize);
};
exports.sfilterToSearchQuery = sfilterToSearchQuery;
var hfilterToSearchQuery = function (hfilter, currencyId, langId, pageSize) {
    if (pageSize === void 0) { pageSize = 24; }
    return stateToSearchQuery_1.stateToSearchQuery({
        hfilter: hfilter,
        layout: {
            currencies: {
                currentCurrencyId: currencyId,
            },
            language: {
                current: langId,
            },
        },
    }, pageSize);
};
exports.hfilterToSearchQuery = hfilterToSearchQuery;
var applyMapSearchToSearchQuery = function (searchQuery, searchSet) {
    var newSearchQuery = __assign({}, searchQuery);
    if (searchSet.isMap)
        newSearchQuery.isMap = searchSet.isMap;
    if (searchSet.mapDetailsType)
        newSearchQuery.mapDetailsType = searchSet.mapDetailsType;
    if (searchSet.geoString)
        newSearchQuery.geoString = searchSet.geoString;
    if (searchSet.zoomLevel)
        newSearchQuery.zoomLevel = searchSet.zoomLevel;
    return newSearchQuery;
};
exports.applyMapSearchToSearchQuery = applyMapSearchToSearchQuery;
/* Convert a search set object to building page url */
var getBuildingLinkFromSearchSet = function (searchSet) {
    var langs, lang, response, buildingId, name;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects_1.select(RootSaga_1.getAvailableLanguages)];
            case 1:
                langs = _a.sent();
                lang = langs.filter(function (it) { return it.id === searchSet.languageId; })[0].code1;
                return [4 /*yield*/, effects_1.call(PlaceFollowedApiSaga_1.checkPlaceFollowedApi, searchSet.keyword, SfilterTypeGroup_1.ListingPurposeType.toSfilterType(searchSet.listingTypeId), lang)];
            case 2:
                response = _a.sent();
                if (!response || !response.data || !response.data.buildingId)
                    return [2 /*return*/, ''];
                buildingId = response.data.buildingId;
                name = format_1.default.normalize(searchSet.keyword);
                return [2 /*return*/, "/" + lang + "/building/" + name + "/" + buildingId];
        }
    });
};
exports.getBuildingLinkFromSearchSet = getBuildingLinkFromSearchSet;
/**
 * Get saved searches from server if logged in. Seperate them into categories
 * - Saved Searches
 * - Following Places
 */
var watchSetSaveSearchFromRemote = function () {
    var isGuestUser, response, saveSearches, savedSearches, followingPlaces;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 8];
                return [4 /*yield*/, effects_1.take(SfavAction_1.default.SET_SAVE_SEARCH_FROM_REMOTE)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.select(stateFilter_1.isUserGuest)];
            case 2:
                isGuestUser = _a.sent();
                if (isGuestUser)
                    return [3 /*break*/, 0];
                return [4 /*yield*/, effects_1.call(SaveSearchApiSaga_1.getSaveSearchCriteriaApi)];
            case 3:
                response = _a.sent();
                if (!(response && response.data.result && response.data.result.status === 2)) return [3 /*break*/, 5];
                saveSearches = response.data.searchSets;
                if (!saveSearches)
                    saveSearches = [];
                savedSearches = saveSearches.filter(filterSavedSeaches);
                followingPlaces = saveSearches.filter(filterFollowPlaces);
                return [4 /*yield*/, effects_1.put(SfavAction_1.default.setSaveSearchList(savedSearches))];
            case 4:
                _a.sent();
                return [3 /*break*/, 7];
            case 5: return [4 /*yield*/, effects_1.put(SfavAction_1.default.setSaveSearchList([]))];
            case 6:
                _a.sent();
                _a.label = 7;
            case 7: return [3 /*break*/, 0];
            case 8: return [2 /*return*/];
        }
    });
};
/**
 * Listen to Saved search item rows clicks, redirect user to
 * building / district / etc.. page base on its type
 */
var watchSaveSearchResultClicked = function () {
    var payload, searchSet, href, _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                if (!true) return [3 /*break*/, 9];
                return [4 /*yield*/, effects_1.take(SfavAction_1.default.ON_SAVE_SERACH_CLICKED)];
            case 1:
                payload = (_b.sent()).payload;
                searchSet = payload;
                href = '';
                _a = searchSet.searchSaveSetType;
                switch (_a) {
                    case SaveSearchSet_1.SearchSaveSetType.District: return [3 /*break*/, 2];
                    case SaveSearchSet_1.SearchSaveSetType.Building: return [3 /*break*/, 4];
                }
                return [3 /*break*/, 6];
            case 2: return [4 /*yield*/, effects_1.call(getDistrictLinkFromSearchSet, searchSet)];
            case 3:
                href = _b.sent();
                return [3 /*break*/, 8];
            case 4:
                if (!searchSet.keyword) return [3 /*break*/, 6];
                return [4 /*yield*/, effects_1.call(getBuildingLinkFromSearchSet, searchSet)];
            case 5:
                href = _b.sent();
                return [3 /*break*/, 8];
            case 6: return [4 /*yield*/, effects_1.call(searchSetToUrlAsync, searchSet)];
            case 7:
                href = _b.sent();
                _b.label = 8;
            case 8:
                if (href) {
                    window.location.href = href;
                }
                return [3 /*break*/, 0];
            case 9: return [2 /*return*/];
        }
    });
};
/**
 * Given a Search Filter object, convert to Search Query object
 * and then to URL
 */
var searchSetToUrlAsync = function (searchSet) {
    var currentHfilter, hfilter, pageSize, searchQuery, url;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                searchSet.hasMaidRoom = searchSet.hasMaidRoom ? true : false;
                searchSet.hasOutdoorSpace = searchSet.hasOutdoorSpace ? true : false;
                searchSet.hasParking = searchSet.hasParking ? true : false;
                return [4 /*yield*/, effects_1.select(getCurrentHfilter)];
            case 1:
                currentHfilter = _a.sent();
                return [4 /*yield*/, effects_1.call(UpdateSaveSearchCallSaga_1.searchSetToHfilter, searchSet, currentHfilter)];
            case 2:
                hfilter = _a.sent();
                return [4 /*yield*/, effects_1.select(GlobalCallSaga_1.getResultPageSize)];
            case 3:
                pageSize = _a.sent();
                return [4 /*yield*/, effects_1.call(hfilterToSearchQuery, hfilter, searchSet.currencyId, searchSet.languageId, pageSize)];
            case 4:
                searchQuery = _a.sent();
                return [4 /*yield*/, effects_1.call(setOrderToSearchQuery_1.setSortOrderToSearchQuery, searchSet.orderBy, searchSet.sortBy, searchQuery)];
            case 5:
                searchQuery = _a.sent();
                return [4 /*yield*/, effects_1.call(searchQueryToUrl_1.searchQueryToUrl, searchQuery)];
            case 6:
                url = _a.sent();
                if (searchSet.userSearchSetId)
                    return [2 /*return*/, url + "#" + getSearchIdHash(searchSet.userSearchSetId)];
                return [2 /*return*/, url];
        }
    });
};
exports.searchSetToUrlAsync = searchSetToUrlAsync;
var watchSetSaveSearchList = function () {
    var payload;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 3];
                return [4 /*yield*/, effects_1.take(SfavAction_1.default.SET_SAVE_SEARCH_LIST)];
            case 1:
                payload = (_a.sent()).payload;
                return [4 /*yield*/, effects_1.put(SfavAction_1.default.onSetSaveSearchList(payload))];
            case 2:
                _a.sent();
                return [3 /*break*/, 0];
            case 3: return [2 /*return*/];
        }
    });
};
var watchRemoveSaveSearch = function () {
    var action;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 3];
                return [4 /*yield*/, effects_1.take(SfavAction_1.default.ON_REMOVE_SAVE_SERACH_CLICKED)];
            case 1:
                action = _a.sent();
                return [4 /*yield*/, effects_1.fork(SfavSaveSearchCallSaga_1.sfavSaveSearchCallSagas.doRemoveSaveSearch, action.payload)];
            case 2:
                _a.sent();
                return [3 /*break*/, 0];
            case 3: return [2 /*return*/];
        }
    });
};
var sfavSaveSearchSagas = {
    watchSetSaveSearchFromRemote: watchSetSaveSearchFromRemote,
    watchSaveSearchResultClicked: watchSaveSearchResultClicked,
    watchSetSaveSearchList: watchSetSaveSearchList,
    watchRemoveSaveSearch: watchRemoveSaveSearch,
};
exports.sfavSaveSearchSagas = sfavSaveSearchSagas;
